const mobileRowHeight = (height) => Math.max(44, height ?? 0)

export function mobileAccountsGridOptions(desktop, mobile, touch = mobile) {
  if (!mobile && !touch) return desktop

  const detail = desktop.detailCellRendererParams
  return {
    ...desktop,
    rowHeight: mobileRowHeight(desktop.rowHeight),
    ...(mobile
      ? {
          defaultColDef: {
            ...desktop.defaultColDef,
            filter: false,
            floatingFilter: false,
            suppressHeaderFilterButton: true,
          },
          rowSelection: false,
          sideBar: false,
        }
      : {}),
    detailCellRendererParams: {
      ...detail,
      detailGridOptions: {
        ...detail.detailGridOptions,
        rowHeight: mobileRowHeight(detail.detailGridOptions.rowHeight),
      },
    },
  }
}
